import { useEffect, useState } from "react";
import { setAsset, setAssetLocalPath } from "../lib/images";
import { hasLocalImage, getLocalImageSrc, writeImageFromUrl } from "../lib/offlineStore";

// Local-d'abord pour un logo/symbole de set, même mécanique que
// useCardImage (voir ce fichier pour le raisonnement) : démarre sur l'URL
// réseau, bascule sur le cache local si déjà synchronisé par useOfflineSync,
// et programme un téléchargement en arrière-plan sinon (cache-as-you-go).
export function useSetAsset(setId, kind, url) {
  const remoteSrc = url ? setAsset(url) : null;
  const [src, setSrc] = useState(remoteSrc);

  useEffect(() => {
    setSrc(remoteSrc);
    if (!remoteSrc || !setId) return;
    const path = setAssetLocalPath(setId, kind, url);
    let cancelled = false;

    if (hasLocalImage(path)) {
      getLocalImageSrc(path).then(local => {
        if (!cancelled && local) setSrc(local);
      });
    } else {
      writeImageFromUrl(path, remoteSrc);
    }

    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setId, kind, url]);

  return src;
}
